import Vue from "vue";
import App from "./App.vue";
import Analytics from "./Analytics.vue"
import "@/assets/styles/index.css";
import moment from "moment";
import VueRouter from "vue-router";

Vue.use(VueRouter);
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("dddd Do MMMM YYYY h:mma");
  }
});

Vue.use(Analytics)
/**
 * Vue filter to round the decimal to the given place.
 * http://jsfiddle.net/bryan_k/3ova17y9/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
 Vue.filter('round', function(value, decimals) {
  if(!value) {
    value = 0;
  }

  if(!decimals) {
    decimals = 0;
  }

  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return value;
});
Vue.config.productionTip = false;

import router from "./router.js";
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

function matchesConfiguredBase(url, base) {
  try {
    const target = new URL(url);
    const configured = new URL(base);
    const configuredPath = configured.pathname.replace(/\/$/, "");
    const targetPath = target.pathname.replace(/\/$/, "");
    return target.origin === configured.origin && (
      !configuredPath ||
      targetPath === configuredPath ||
      target.pathname.startsWith(`${configuredPath}/`)
    );
  } catch (e) {
    return false;
  }
}

function isInternalApiRequest(url) {
  if (!url) return true;
  if (!/^https?:\/\//i.test(url)) return true;
  const bases = [
    process.env.VUE_APP_BASE_URL,
    process.env.VUE_APP_SOURCE_INPUT_API_BASE_URL,
    process.env.VUE_APP_SNAPSHOT_API_BASE,
  ].filter(Boolean);
  return bases.some((base) => matchesConfiguredBase(url, base));
}

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  if (!config.headers.Authorization && !config.headers.authorization && isInternalApiRequest(config.url)) {
    const token = localStorage.getItem("token") || localStorage.getItem("public_token");
    if (token) config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
